module.exports = __webpack_public_path__ + "img/hr-V-R-135-load-standup-base.8563cd94.png";